import React, { Component } from 'react'
import { stepThousand, keyUpFormat } from '../../utility/format.js'
import {
    AgeMask,
    DollarMask,
    Form,
    MaskedInputControl,
    PercentMask,
    SelectControl,
    SubmitControl,
} from '../../components/Form';

export default class GiftAnnuityInput extends Component {

    render() {
        var params = this.props.params;
        var maxPayoutRate = this.props.clientDefaults[`${this.props.page.backendKey}MaximumPayoutRate`]
        var minPayoutRate = this.props.clientDefaults[`${this.props.page.backendKey}MinimumPayoutRate`]

        var errors = this.props.errors;

        var controls = [];

        controls.push(<SelectControl
            label="Trust Duration"
            key="trustDuration"
            id="trustDuration"
            options={{
                'fixed': 'Fixed Number of Years',
                'single': 'Rest of Your Life',
                'double': 'Rest of Your or Another Person\'s Life',
            }}
            value={ params.type }
            onChange={ (selected) => {
                this._updateParams({type: selected});
                this.props.onBlur();
            }} />);

        if (params.type === 'fixed') {

            controls.push(<MaskedInputControl
                label="Number of Years"
                key="years"
                id="years"
                value={ params.years }
                error={ errors.get('years') }
                onBlur={ () => this.props.onBlur() }
                onChange={ (e) => {
                    var years = parseInt(e.target.value, 10);
                    this._updateParams({years: years});
                } }
                onIncrement={ (amount) => {
                    var years = this.props.params.years || 1;

                    if (amount < 0) {
                        this._updateParams({years: years - 1});
                    } else {
                        this._updateParams({years: years + 1});
                    }
                }}
                onKeyUp={e => {
                    this._updateParams({ years: keyUpFormat(e,{step:1}) })
                    this.props.onBlur();
                }}
                mask={ AgeMask } />);

        }

        if (params.type === 'single' || params.type === 'double') {
            controls.push(<MaskedInputControl
                label="Your Age"
                key="age1"
                id="age1"
                value={ params.age1 }
                error={ errors.get('age1') }
                onBlur={ () => this.props.onBlur() }
                onChange={ (e) => {
                    var age1 = parseInt(e.target.value, 10);
                    this._updateParams({age1: age1});
                } }
                onIncrement={ (amount) => {
                    var age1 = this.props.params.age1 || 1;

                    if (amount < 0) {
                        this._updateParams({age1: age1 - 1});
                    } else {
                        this._updateParams({age1: age1 + 1});
                    }
                }}
                onKeyUp={e => {
                    this._updateParams({ age1: keyUpFormat(e,{step:1}) })
                    this.props.onBlur();
                }}
                mask={ AgeMask } />);
        }
        
        if (params.type === 'double') {
            controls.push(<MaskedInputControl
                label="Other Person's Age"
                key="age2"
                id="age2"
                value={ params.age2 }
                error={ errors.get('age2') }
                onBlur={ () => this.props.onBlur() }
                onChange={ (e) => {
                    var age2 = parseInt(e.target.value, 10);
                    this._updateParams({age2: age2});
                } }
                onIncrement={ (amount) => {
                    var age2 = this.props.params.age2 || 1;

                    if (amount < 0) {
                        this._updateParams({age2: age2 - 1});
                    } else {
                        this._updateParams({age2: age2 + 1});
                    }
                }}
                onKeyUp={e => {
                    this._updateParams({ age2: keyUpFormat(e,{step:1}) })
                    this.props.onBlur();
                }}
                mask={ AgeMask } />);
        }

        controls.push(<MaskedInputControl
            label="Gift Amount"
            key="giftAmount"
            id="giftAmount"
            value={ params.giftAmount }
            error={ errors.get('giftAmount') }
            onBlur={ () => this.props.onBlur() }
            onChange={ (e) => {
                var giftAmount = parseInt(e.target.value.replace(/\D+/g, ''), 10);
                this._updateParams({ giftAmount: giftAmount });
            } }
            onIncrement={ (amount) => {
                var giftAmount = this.props.params.giftAmount || 1;

                if (amount < 0) {
                    this._updateParams({giftAmount: giftAmount - 1000});
                } else {
                    this._updateParams({giftAmount: giftAmount + 1000});
                }
            }}
            onKeyUp={e => {
                this._updateParams({ giftAmount: keyUpFormat(e,stepThousand) })
                this.props.onBlur();
            }}
            mask={ DollarMask } />);

        controls.push(<SelectControl
            label="Trust Type"
            key="trustType"
            id="trustType"
            options={{
                'variable': 'Variable Payments (Unitrust)',
                'fixed': 'Fixed Payments (Annuity Trust)'
            }}
            value={ params.trustType }
            onChange={ (selected) => {
                this._updateParams({trustType: selected});
                this.props.onBlur();
            }} />);

        controls.push(<MaskedInputControl
            label="Payout Rate"
            key="payoutRate"
            id="payoutRate"
            page={this.props.page}
            error={ errors.get('payoutRate') }
            value={ (params.payoutRate * 100).toFixed(2) }
            onBlur={ () => this.props.onBlur() }
            onChange={ (e) => {
                var percentage = parseFloat(e.target.value.replace('%', ''));
                var rate = percentage / 100;
                this._updateParams({
                    payoutRate: rate,
                });
            } }
            onIncrement={ (amount) => {
                var payoutRate = this.props.params.payoutRate || 1;
                var decrease = payoutRate - .01
                var increase = payoutRate + .01
                if (amount < 0) {
                    this._updateParams({payoutRate: decrease < minPayoutRate ? minPayoutRate : decrease});
                } else {
                    this._updateParams({payoutRate: increase > maxPayoutRate ? maxPayoutRate : increase});
                }
            }}
            mask={ PercentMask } />);

        controls.push(<SubmitControl
            key="submit"
            disabled={ errors.count() > 0 }
            color='green'
            loading={ this.props.loading }
            label="Calculate" />);

        return (
            <Form
                onSubmit={ (e) => {
                    e.preventDefault();
                    this.props.onSubmit();
                }}
                controls={ controls }/>
        );
    }

    _updateParams(updates) {
        var params = this.props.params;
        params = Object.assign(params, updates);
        this.props.onChange(params);
    }

}
